import { useEffect, useState } from "react"

import AddButton from "../ScenarioTypeEditor/AddButton"
import InputWithErrorMessage from "../ScenarioTypeEditor/InputWithErrorMessage"

const AddModel = ({ model, addHandler, uniqueIDs=[], uniqueLabels=[], idGenerator=null }) => {
    const [labelsUnique, setLabelsUnique] = useState(false)
    const [entityType, setEntityType] = useState(null)
    const [newID, setNewID] = useState(null)
    const [newIDErrMsg, setNewIDErrMsg] = useState("")
    const [newLabel, setNewLabel] = useState("")
    const [newLabelErrMsg, setNewLabelErrMsg] = useState("")
    const [readyToAdd, setReadyToAdd] = useState(false)

    const validateForm = () => {
        if ("" === newID) {
            setNewIDErrMsg("Please enter an ID")
        }
        if ("" === newLabel) {
            setNewLabelErrMsg("Please enter a label")
        }
    }

    const changeID = (event) => {
        const {value} = event.target
        setNewID(value)
        setNewIDErrMsg(!uniqueIDs.includes(value) ? "" : "Not Unique")
    }

    const changeLabel = (event) => {
        const {value} = event.target
        setNewLabel(value)
        if (!!idGenerator) {
            setNewID(idGenerator())
        }
        if (labelsUnique) {
            setNewLabelErrMsg(!uniqueLabels.includes(value) ? "" : "Not Unique")
        }
    }

    const onAdd = (event) => {
        validateForm()
        setReadyToAdd(true)
    }



    useEffect(
        () => {
            if (!entityType || entityType !== model.type) {

                setEntityType(model.type)
                setLabelsUnique(model.labelsUnique)
                setNewLabel("")
                setNewID("")
            }
        }, [model, entityType]
    )

    useEffect(
        () => {
            if (readyToAdd) {
                // prevent endless loop
                setReadyToAdd(false)
                if (newIDErrMsg !== "" || newLabelErrMsg !== "") {
                    alert("Please correct errors before submitting")
                } else {
                    //add item
                    addHandler(entityType, newID, newLabel)
                    // set fields to default values
                    setNewID("")
                    setNewIDErrMsg("")
                    setNewLabel("")
                    setNewLabelErrMsg("")
                }
            }
        }, [readyToAdd, addHandler, entityType, newID, newLabel, newIDErrMsg, newLabelErrMsg]
    )


    return (
        <div className="add-entity">
            <table style={{width: "100%"}}>
                <thead>
                    <tr>
                        <th></th>
                        {!idGenerator && <th>ID</th>}
                        <th>Label</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <b>Add {model.name}</b>
                        </td>
                        {!idGenerator &&
                        <td>
                            <InputWithErrorMessage
                                value={newID}
                                errMsg={newIDErrMsg}
                                onChange={changeID}
                            />
                        </td>
                        }
                        <td>
                            <InputWithErrorMessage
                                value={newLabel}
                                size="80"
                                errMsg={newLabelErrMsg}
                                onChange={changeLabel}
                            />
                        </td>
                        <td>
                            <AddButton addHandler={onAdd} />
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    )
}

export default AddModel